import { render } from "./delivery.html?vue&type=template&id=6b717ab0&external"
import script from "./delivery.js?vue&type=script&lang=js&external"
export * from "./delivery.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__